import { PAGINATION } from 'constants/pagination';

export const COMMUNITIES_ADMIN_PAGE_SIZE = PAGINATION.PAGE_SIZE;
export const ORDERING_FIELD = 'comunity_name';
